export function getAmount (str: string) {
  const before = str.indexOf('(')
  if (before !== -1) {
    const number = str.match(/\d+\.\d+/)

    const negativeNumber = '-' + number

    const result = str.replace(/\(\d+\.\d+\)/, negativeNumber)

    return result
  }
  return str
}
